import { StyleSheet } from 'aphrodite';

import { CustomFieldsSuggestions } from '../CustomFieldsSuggestions';

export class CustomFieldsSuggestionPartner extends CustomFieldsSuggestions {

  constructor(props) {
    super(props, {pageForOrgType: 'PARTNER'})
  }
}

const Styles = StyleSheet.create({
})


// WEBPACK FOOTER //
// ./src/screens/admin/partners/CustomFieldsSuggestionPartner.js